import "bootstrap-icons/font/bootstrap-icons.css";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import lettercredit from "assets/images/lettercredit_table.svg";
import { LinkButton } from "components/buttons";

function LetterCredit() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`Letter of
              <span className="jumbotron-subtitle-2">
                Credit-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              When you need your seller to know that you have the financial
              means to import their goods, alrajhi bank Malaysia's Letter of
              Credit-<i>i</i> comes in useful. Often used in international trade
              to eliminate the risks associated with the importer's country, the
              Letter of Credit-i serves as concrete confirmation that your
              seller will receive payment for the goods or services imported by
            </p>
            {/* <img
              style={{ width: "100%" }}
              src={currency}
              className="d-inline-block align-top"
              alt=""
            /> */}
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>
              Express Letter of Credit-<i>i</i>&nbsp; (fully secured against
              deposit account)
            </h3>
          </div>
          <div className="col-xl-8">
            <p>
              <ul>
                <li>
                  ONE DAY issuance for LC-<i>i</i>&nbsp; Letter of Offer with
                  minimum supporting documents and ONLY ONE DAY to get your LC-i
                  out, subject to completion of documentation.
                </li>
                <li>
                  Click Express LC-<i>i</i> &nbsp;Application Checklist for more
                  details.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Letter of Credit Transferrable</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Re-issuance of Import Letter of Credit for transfer to second
              beneficiary, local or foreign.
            </p>
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={lettercredit}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <LinkButton
                text={
                  <span>
                    Letter of Credit-<em>i</em> Applicaton Form
                  </span>
                }
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/LC Form.pdf"
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/4. PDS Letter of Credit Nov 2022.pdf"
                  )
                }
              />
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/tradefinancing/1680579344_Trade Finance Instruments - Fees and Charges.pdf"
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default LetterCredit;
